import './style.scss';

const AccessToaster = props => {
	const { label, description, onReload } = props;

	return (
		<>
			<div className='access-popup__wrapper'></div>
			<div className='access-popup align-center'>
				<div className='access-popup__container space-between'>
					<div className='access-popup__label'>
						{label && <h3>{label}</h3>}
						{description && <span>{description}</span>}
					</div>
					<div className='access-popup__button' onClick={() => onReload()}>
						Reload
					</div>
				</div>
			</div>
		</>
	);
};

export default AccessToaster;
